import { apiExpress } from 'lib/config';
import { useQueryFetch } from '../useQueryFetch';
import { Service } from './Constants';

interface ServiceConnectResponse {
  error: boolean;
  message: string;
}
export const useServiceConnect = (service: Service) => {
  const { data, error, loading, fetchData } = useQueryFetch({});

  const fetch = () => {
    fetchData({
      method: 'get',
      url: `${service}/connect`,
      baseURL: apiExpress,
    });
  };

  //
  const connectData: ServiceConnectResponse = (data && data.data) || null;

  return { connectData, loading, error, fetch };
};
